import styled from '@emotion/styled';

import { su, suPx } from '../../theme/functions/su';
import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';

import { Glyph } from '../../components/common/Glyph';
import { ExternalLink } from '../../components/common/link/ExernalLink';
import { Heading4 } from '../../components/common/text/Heading4';
import { TextRegular } from '../../components/common/text/TextRegular';
import { TextTinyMedium } from '../../components/common/text/TextTinyMedium';
import { Tooltip } from '../../components/common/tooltip/Tooltip';

export function DeprecatedLabel(props) {
  function renderTrigger(triggerRef, triggerProps) {
    return (
      <S.TriggerRoot ref={triggerRef} {...triggerProps}>
        <TextTinyMedium color={theme.color.text_white}>Classic</TextTinyMedium>
      </S.TriggerRoot>
    );
  }

  return (
    <Tooltip offset={suPx(1)} instant={true} renderTrigger={renderTrigger}>
      <S.ContentRoot>
        <S.ContentHeader>
          <Glyph
            size={theme.icon.size_large}
            source={glyph.core.exclamationmarkCircleFill}
            color={theme.color.yellow}
          />

          <Heading4>Deprecated API version</Heading4>
        </S.ContentHeader>

        <TextRegular>You're using an old version of the API for this script.</TextRegular>

        <S.ContentFooter>
          <S.Link url="https://athombv.github.io/com.athom.homeyscript/tutorial-migrate">
            Learn how to upgrade
            <Glyph
              source={glyph.core.squareArrowUpRight}
              color={theme.color.highlight}
              size={theme.icon.size_small}
            />
          </S.Link>
        </S.ContentFooter>
      </S.ContentRoot>
    </Tooltip>
  );
}

const S = (DeprecatedLabel.S = class S {
  static TriggerRoot = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 0 ${su(1)};
    border-radius: 12px;
    background-color: ${theme.color.yellow};
    cursor: pointer;
  `;

  static ContentRoot = styled.div`
    padding: ${su(3)};
  `;

  static ContentHeader = styled.header`
    display: flex;
    align-items: center;
    gap: ${su(1)};
    padding-bottom: ${su(1)};
  `;

  static ContentFooter = styled.footer`
    padding-top: ${su(1)};
  `;

  // Extract to component and use in other places. with iconExternalLink
  static Link = styled(ExternalLink)`
    display: inline-grid;
    grid-auto-flow: column;
    grid-gap: 5px;
    align-items: center;
    text-decoration: none;
    outline: 0;

    &:hover {
      text-decoration: underline;
    }
  `;
});
